import React, { useEffect, useState } from 'react';
import {
  formatNextDue,
  formatTimeAgo,
  getGlucoseColorClass,
  getTrendArrow,
} from '../utils/glucoseDisplay';
import type { GlucoseReading } from '../hooks/useProfileCgmReading';
import Avatar from './Avatar';
import './CgmProfileCard.css';

type Props = {
  profileName: string;
  profileImageUrl?: string;
  reading: GlucoseReading | null;
};

const CgmProfileCard: React.FC<Props> = ({ profileName, profileImageUrl, reading }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const gv = reading?.glucose_value;
  const color = getGlucoseColorClass(gv);

  return (
    <div className="cgm-profile-card" role="status" aria-live="polite">
      <div className="cgm-profile-card-avatar" aria-hidden>
        <Avatar profileImageUrl={profileImageUrl} size={40} />
      </div>
      <div className="cgm-profile-card-body">
        <div className="cgm-profile-card-name">{profileName}</div>
        <div className="cgm-profile-card-glucose-row">
          <span className={`cgm-profile-card-value cgm-${color}`}>{gv != null ? Math.round(gv) : '—'}</span>
          <span className="cgm-profile-card-unit">
            mg/dL
            <span className={`cgm-profile-card-trend cgm-${color}`}>{getTrendArrow(reading?.trend)}</span>
          </span>
        </div>
      </div>
      <div className="cgm-profile-card-meta">
        <p className="cgm-profile-card-last">Last: {formatTimeAgo(now, reading?.timestamp)}</p>
        <p className="cgm-profile-card-next">Next: {formatNextDue(now, reading?.timestamp)}</p>
      </div>
      <span className="cgm-profile-card-chevron" aria-hidden>
        ›
      </span>
    </div>
  );
};

export default CgmProfileCard;
